<template>
  <div class="bg-green-200 p-4 rounded-md">
    <h2 class="text-xl font-semibold mb-4">Hörhilfenverordnung (Muster 15)</h2>

    <!-- Trennlinie -->
    <div class="border-b border-gray-400 my-4"></div>

    <!-- Hearing Loss Data -->
    <div class="mb-4 flex justify-between">
      <button @click="openModal('rechts')" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full mr-2">
        Rechtes Ohr
      </button>
      <button @click="openModal('links')" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full ml-2">
        Linkes Ohr
      </button>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="bg-white p-4 rounded-md">
        <HearingLossDataForm :side="modalSide" @close="closeModal" />
      </div>
    </div>

    <!-- Trennlinie -->
    <div class="border-b border-gray-400 my-4"></div>

    <!-- Basic Information -->
    <div class="mb-4 grid grid-cols-2 gap-4">
      <input
        v-model="eRezeptStore.muster15formData.diagnosisICD"
        type="text"
        placeholder="Diagnose ICD"
        class="p-2 border rounded"
      />
      <input
        v-model="eRezeptStore.muster15formData.diagnosisText"
        type="text"
        placeholder="Diagnosetext"
        class="p-2 border rounded"
      />
    </div>

    <!-- Checkboxes -->
    <div class="mb-4 flex space-x-4">
      <label class="flex items-center">
        <input
          v-model="eRezeptStore.muster15formData.folgeversorgung"
          type="checkbox"
          class="mr-2"
        />
        Folgeversorgung
      </label>
      <label class="flex items-center">
        <input
          v-model="eRezeptStore.muster15formData.bvg"
          type="checkbox"
          class="mr-2"
        />
        BVG
      </label>
    </div>

    <!-- Accident Type -->
    <div class="mb-4">
      <select
        v-model="eRezeptStore.muster15formData.accidentType"
        class="w-full p-2 border rounded"
      >
        <option value="">Unfallart wählen</option>
        <option value="1">Arbeitsunfall</option>
        <option value="2">Wegeunfall</option>
        <option value="3">Berufskrankheit</option>
      </select>
    </div>

    <!-- Notes -->
    <div class="mb-4">
      <textarea
        v-model="eRezeptStore.muster15formData.note"
        placeholder="Anmerkungen"
        class="w-full p-2 border rounded"
        rows="3"
      ></textarea>
    </div>

    <!-- Submit Button -->
    <div class="mt-4">
      <button
        @click="createERezept"
        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        E-Rezept erstellen
      </button>
    </div>
  </div>
</template>

<script>
import { useERezeptStore } from '../../stores/eRezeptStore';
import HearingLossDataForm from './HearingLossDataForm.vue';
import { useDbStore } from '../../stores/dbStore';

export default {
  name: 'Muster15Form',
  components: {
    HearingLossDataForm,
  },
  emits: ['save'],
  data() {
    return {
      showModal: false,
      modalSide: null,
    };
  },
  methods: {
    openModal(side) {
      this.showModal = true;
      this.modalSide = side;
    },
    closeModal() {
      this.showModal = false;
      this.modalSide = null;
    },
  },
  setup(props, { emit }) {
    const eRezeptStore = useERezeptStore();

    const createERezept = async () => {
      try {
        const dbStore = useDbStore();
        dbStore.setMuster15Data(eRezeptStore.muster15formData);
        await eRezeptStore.createERezept();
        emit('save');
      } catch (error) {
        console.error('Error creating E-Rezept:', error);
      }
    };

    return {
      eRezeptStore,
      createERezept,
    };
  },
};
</script>